import { render, staticRenderFns } from "./ItemsSortBy.vue?vue&type=template&id=15f98d6a&scoped=true"
import script from "./ItemsSortBy.vue?vue&type=script&lang=js"
export * from "./ItemsSortBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f98d6a",
  null
  
)

export default component.exports